import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {FdAclService} from '../../services/infrastructure/auth/acl/fd-acl/fd-acl.service';
import {GuardService} from '../guard/guard.service';
import {UserAclService} from '../../services/infrastructure/auth/acl/user-acl/user-acl.service';

export const libraryGuard: CanActivateFn = () => {
  const guardService = inject(GuardService);
  const fdAclService = inject(FdAclService);
  const userAclService = inject(UserAclService);

  const hasPermissions = !fdAclService.accessDeniedFeatureGCC() || userAclService.isLibraryAdmin()
    || userAclService.isApplicationAdmin();

  if (hasPermissions) {
    return true;
  }
  return guardService.createRedirectUrlTree();
};
